import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, BrainCircuit, CalendarCheck, ClipboardCheck, Sparkles, UserRoundCheck } from "lucide-react";
import SEOHead from "../components/SEOHead";
import { useSettings } from "../context/SettingsContext";
import { getSeoPage } from "../utils/seoPages";
import ZcalEmbed from "../components/ZcalEmbed";
import { api } from "../lib/api";

export default function DiagnosticStrategique() {
  const { settings } = useSettings();
  const seo = getSeoPage(settings, "/diagnostic-strategique");
  const bookingUrl = settings.zcal_booking_url || "https://zcal.co/rudylemoine/SFLearning";

  useEffect(() => {
    api.post("/tracking/event", { event: "diagnostic_page_view", path: "/diagnostic-strategique" }).catch(() => {});
  }, []);

  return (
    <div className="bg-brand-mint min-h-screen" data-testid="diagnostic-strategique-page">
      <SEOHead
        title={seo.title}
        description={seo.description}
        url={typeof window !== "undefined" ? window.location.href : ""}
        type="website"
      />

      <section className="relative overflow-hidden border-b border-emerald-100">
        <div className="absolute inset-0 dot-grid opacity-60" />
        <div
          className="absolute right-[-180px] top-[-220px] w-[560px] h-[560px] rounded-full"
          style={{ background: "radial-gradient(closest-side, rgba(244,161,0,0.22), transparent 70%)" }}
        />
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20 relative">
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-gray-600 hover:text-brand-green mb-8">
            <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
          </Link>

          <div className="max-w-4xl">
            <span className="badge mb-5"><Sparkles className="w-3.5 h-3.5" /> Diagnostic offert SF Learning</span>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-tight">
              Réserve ton <span className="text-brand-green">diagnostic stratégique</span> offert
            </h1>
            <p className="mt-6 text-lg text-gray-700 max-w-2xl leading-relaxed">
              Un échange pour identifier les blocages invisibles qui freinent ton recrutement,
              ton leadership et la croissance de ton entreprise.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
              <div className="card p-4 bg-white/90 min-h-[112px]">
                <BrainCircuit className="w-5 h-5 text-brand-green mb-2" />
                <p className="font-semibold text-sm">Clarté sur tes blocages</p>
              </div>
              <div className="card p-4 bg-white/90 min-h-[112px]">
                <UserRoundCheck className="w-5 h-5 text-brand-green mb-2" />
                <p className="font-semibold text-sm">Lecture de ta posture</p>
              </div>
              <div className="card p-4 bg-white/90 min-h-[112px]">
                <ClipboardCheck className="w-5 h-5 text-brand-green mb-2" />
                <p className="font-semibold text-sm">Plan d'action concret</p>
              </div>
              <div className="card p-4 bg-white/90 min-h-[112px]">
                <CalendarCheck className="w-5 h-5 text-brand-green mb-2" />
                <p className="font-semibold text-sm">Choisis ton créneau</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14">
        <div className="card overflow-hidden bg-white" data-testid="diagnostic-zcal-embed">
          <div className="p-5 border-b border-emerald-100">
            <p className="label">Calendrier</p>
            <h2 className="font-heading text-2xl font-bold">Prendre rendez-vous avec SF Learning</h2>
            <p className="text-sm text-gray-600 mt-2">
              Choisis directement ton créneau ci-dessous, sans quitter le site.
            </p>
          </div>
          <ZcalEmbed
            url={bookingUrl}
            minHeight={760}
            className="w-full bg-white"
            onLoaded={() => api.post("/tracking/event", { event: "diagnostic_calendar_view", path: "/diagnostic-strategique" }).catch(() => {})}
          />
        </div>
      </section>
    </div>
  );
}
